module.exports = __webpack_public_path__ + "img/chart_title.d227c988.png";